import React from "react";
import { MDBIcon, Input } from "mdbreact";

const ImageUploadBox = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "20px", maxWidth: "100%" }}>
      <label htmlFor="imageUpload" style={{ cursor: "pointer" }}>
        <div className="image-upload-box">
          <MDBIcon icon="fas fa-plus-circle" size="2x" />
          <p style={{ marginTop: "10px" }}>Upload Picture</p>
        </div>
      </label>
      <Input type="file" id="imageUpload" style={{ display: "none" }} />
    </div>
  );
};

export default ImageUploadBox;
